import { render, staticRenderFns } from "./PrtRpt.vue?vue&type=template&id=124d17a5&"
import script from "./PrtRpt.vue?vue&type=script&lang=js&"
export * from "./PrtRpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports